import { styled } from "@mui/material/styles";

export const PageHeader = styled("header")`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;
